import { render, staticRenderFns } from "./charterForm.vue?vue&type=template&id=cb529f50&scoped=true&"
import script from "./charterForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./charterForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./charterForm.vue?vue&type=style&index=0&id=cb529f50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb529f50",
  null
  
)

export default component.exports